import * as React from "react";
// import CartItemSubTotal from "../../../component/Global/Cart/CartItemSubTotal";
// import store from "../../../storeWire";
import Checkout from "@system/config/checkout";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import liveAuth from "src/helper/liveAuth";
import System from "src/helper/system";
import Common from "../Common";
import { useCartStore } from "src/hooks/cart";
import { useEffect, useState } from "react";
import { isNumber } from "underscore";
import Helper from "src/support/Helper";
import StripPriceLoader from "src/component/StripPriceLoader";
import Constants from "src/support/Constants";
import CartSummary from "src/pages/CartSummary";
import useReduxState from 'src/hooks/useReduxState';

const CartShippingDetail = (props) => {
  const [__check] = useAxiosIndicatorCheck();
  const [{ VAT_DATA, CART_SHIPPING_ADDRESS_ID, CART_DATA, CART_PRODUCT_DATA, CART_READY_TO_GO_FOR_CHECKOUT, CART_DATA_ERROR },
    { get_vat_data, get_vat_total, get_cart_list_subtotal },
    { },] = useCartStore();

  const [vatTotal, setVatTotal] = useState(0)
  const [subTotal, setSubTotal] = useState(0)
  const [load, setLoad] = useState(false)
  const [isCartPriceAlert] = useReduxState(false, 'setCartPriceAlert')

  // NOTE : for now VAT data is commented
  // useEffect(() => {
  //   async function fetchHere() {
  //     await get_vat_data(); // API call for VAT data
  //   }
  //   fetchHere();
  // }, []); 

  useEffect(() => {
    setSubTotal(get_cart_list_subtotal(CART_DATA))
    // get_vat_total(CART_DATA, VAT_DATA)

  }, [CART_DATA]);

  const authLoggedIn = (keyIndex) => {
    return liveAuth.check();
  };

  const checkOutButtonDisable = () => {
    if (isCartPriceAlert) {
      return true;
    }

    if (CART_DATA && CART_DATA.length > 0) {
      let filteredArray = CART_DATA.filter((itm) => {
        return itm.subtotal <= 0 || itm.unitPrice <= 0
      });

      if (filteredArray && filteredArray.length > 0) {
        return true;
      }
    }


    if (!(Object.entries(CART_DATA).length > 0 && CART_DATA && CART_DATA.length > 0)) {
      return true;
    }
    if (authLoggedIn() === false) {
      return false;
    }
    if(new Common().checkVendorExcluded(CART_DATA) === true)
    {
      return true;
    }
    if (shippingModalDecisionMaker() === true) {
      return false;
    }
    if (new Common().getInventoryOutOfStockFlag(CART_DATA, CART_PRODUCT_DATA) === true) {
      return false;
    }
    if (checkOutDecisionMaker() === false) {
      return true;
    }
    return false;
  };

  const checkOutAction = () => {
    if (authLoggedIn() === false) {
      System.popup("GuestPopupActionButton", {
        title: "Sign In",
        body: "Sign In to continue with Avnet",
      });
      return;
    }

    if (shippingModalDecisionMaker() === true) {
      System.popup("ShippingAddressPopup");
      return;
    }

    if (checkOutDecisionMaker() === true) {
      setLoad(true);
      window.location.href = Checkout.getCheckOutRouteURL();
      return;
    } else {
      // alert('error')
      // reCartInitiated();
      return;
    }

    // return checkOutDecisionMaker();
  };

  const checkOutDecisionMaker = () => {
    if (authLoggedIn() === false) {
      return false;
    }
    if (__check(["CART_API_CALL", "CART_OPERATION_API_CALL"]).status) {
      return false;
    }
    if (new Common().getInventoryOutOfStockFlag(CART_DATA, CART_PRODUCT_DATA) === true) {
      return false;
    }
    if(new Common().checkVendorExcluded(CART_DATA) === true)
    {
      return false;
    }
    if (CART_READY_TO_GO_FOR_CHECKOUT === true) {
      return true;
    }
    return false;
  };

  const shippingModalDecisionMaker = () => {
    if (CART_SHIPPING_ADDRESS_ID === undefined || CART_SHIPPING_ADDRESS_ID === null || CART_SHIPPING_ADDRESS_ID === "" || CART_SHIPPING_ADDRESS_ID === 0) {
      return true;
    }
    return false;
  };

  const checkOutActionMaker = () => {
    if (checkOutButtonDisable() === false && CART_DATA_ERROR === false) {
      checkOutAction();
      return true;
    }
    return false;
  };


  return (
    <>
      {__check(["VIEW_CART_API_CALL", "CART_API_CALL", "CART_OPERATION_API_CALL"]).status ?
        <StripPriceLoader />
        :
        <>
          <div className="cart-shopping-detail">
            <div className="cart-shipping-detail">
              <div className="bs5 row">

                <CartSummary summaryFor={Constants.cartSummary.SUBTOTAL} itemLength={CART_DATA.length} subTotal={Helper.getFormatNumber(Number(subTotal))} />
              </div>
              <div className="bs5 row">
                <div className="col-7">
                  <span>Estimated Shipping: </span>
                </div>
                <div className="col-5 text-end font_bold_currency">
                  <span>--</span>
                </div>
              </div>
              {authLoggedIn() && (
                <div className="bs5 row font_bold_currency">
                  <div className="col-7">
                    <span>Estimated VAT: </span>
                  </div>
                  <div className="col-5 text-end ">
                    {(!CART_SHIPPING_ADDRESS_ID || vatTotal === 0) && (
                      <span>--</span>
                    )}
                    {CART_SHIPPING_ADDRESS_ID && isNumber(vatTotal) && Number(vatTotal) > 0 && (
                      <span>
                        {isNumber(vatTotal)
                          ? new Intl.NumberFormat(Helper.getCurrencyFormat(window.mct), {
                            style: "currency",
                            currency: window.mct,
                          }).format(vatTotal).replace(/\s/g, "")
                          : ""}
                      </span>
                    )}
                  </div>
                </div>
              )}
            </div>
            {/* <CartItemSubTotal isCartPricing={true} /> */}
            <div className="bs5 row m-0 mini-cart-item-total">
              <div className="order-total" >
                <div className="bs5 row font_bold_currency">
                  <div className="col-6">
                    <span>Order Total: </span>
                  </div>
                  <div className="col-6 text-end">
                    <span className='subtotal-currency'>{window.mct}</span>
                    <span className="ms-1">
                      {isNumber(subTotal) ? Helper.getFormatNumber(
                        Number(subTotal), window.mct, window.mcs, 2, true, false) : ""}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="shopping-option text-center">
              {((CART_SHIPPING_ADDRESS_ID || CART_SHIPPING_ADDRESS_ID > 0) && __check(["CART_API_CALL", "CART_OPERATION_API_CALL", "VIEW_CART_API_CALL"]).status) && (
                <a href={void 0} className="bs5 btn btn-primary d-block most-viewd-item-btn m-auto">
                  <i className="fa add-cart-spinner fa-spin" />
                </a>
              )}
              {!__check(["CART_API_CALL", "CART_OPERATION_API_CALL", "VIEW_CART_API_CALL"]).status && (
                <a href={void 0} className={`bs5 btn btn-primary d-block most-viewd-item-btn m-auto ${load && 'h-30'}`}
                  disabled={checkOutButtonDisable() ? true : (CART_DATA_ERROR ? true : false)}
                  onClick={(e) => { load ? e.preventDefault() : checkOutActionMaker(); }}>
                  <div className='d-flex align-items-center justify-content-center line-height-20'>
                    {load &&
                      <div>
                        <i className="fa add-cart-spinner fa-spin" />
                      </div>
                    }
                    {!load &&
                      <>
                        <span className="fa add-cart-lock-icon me-1" /> Checkout
                      </>
                    }
                  </div>
                </a>
              )}

              <div className="text-center d-flex align-items-center justify-content-center">
                <a href={System.getHomepageUrl()} className="my-2" >
                  Continue Shopping
                </a>
              </div>
              <span className="instruction text-black-stone">
                VAT and shipping will be calculated later
              </span>
            </div>
          </div>
        </>
      }
    </>
  );
};

export default CartShippingDetail;

